<div
  class="jf-app-toolbar"
  *ngIf="(runningInPortal$ | async) === false && (runningInIFrame$ | async) === false"
>
  <span class="standalone-toolbar-spacer"></span>

  <jf-button
    [iconPosition]="'right'"
    [icon]="'arrowRight'"
    [variant]="'ghost'"
    (doClick)="doLogout()"
    >Abmelden</jf-button
  >
</div>

<div class="content-outlet">
  <router-outlet></router-outlet>
</div>
